<template>
	<div>
		<b-row class="mb-4 mt-0" align-h="end">
			<b-col md="3">
				<b-button size="sm" block variant="primary" v-b-modal.modal-reporte-nuevo-invent class="mb-0">Nuevo levantamiento
				</b-button>
			</b-col>
		</b-row>
		<b-modal id="modal-reporte-nuevo-invent" scrollable title="Nuevo levantamiento físico de inventario" @hidden="hidden">

			<b-form @submit="onSubmit">
				<b-form-group label="Encargado:" label-for="inv-nombre">
					<b-form-input id="inv-nombre" v-model="form.nombre" required></b-form-input>
				</b-form-group>
			</b-form>

			<template v-slot:modal-footer="{ cancel }">
				<b-button size="sm" variant="" @click="cancel()">
					Cancelar
				</b-button>
				<!-- Button with custom close trigger value -->
				<b-button size="sm" variant="outline-danger" @click="store()">
					Iniciar
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data: () => {
			return {
				form: {
					nombre: '',
				}
			}
		},
		methods: {
			hidden(){
				this.form.nombre = ''
			},
			store(){
				axios.post('inventarios/create', this.form).then(response => {
					if(response.status){
						this.$router.push({name: 'Levantamiento de inventario', params: {id: response.data.id}})
						this.$bvModal.hide('modal-reporte-nuevo-invent')
					}
				})
			},
			onSubmit($evnt){
				$evnt.preventDefault();
				this.store()
			}
		}
	}

</script>
